import React, { useState, useEffect } from "react";
import { putMarca } from "../helpers/rutaMarcas";
import { Modal, Button } from "react-bootstrap";

const ModalFormMarca = ({ marca, handleClose }) => {
  const [formValues, setFormValues] = useState({
    nombre: "",
  });

  useEffect(() => {
    if (marca) {
      setFormValues({
        nombre: marca?.nombre || marca?.marca || "",
      });
    }
  }, [marca]);

  const handleChange = (e) => {
    const { name, value } = e.target;

    setFormValues((prev) => ({
      ...prev,
      [name]: value.toUpperCase(),
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!marca?._id) {
      alert("No se encontró el ID de la marca");
      return;
    }

    if (!formValues.nombre.trim()) {
      alert("Debe ingresar una marca");
      return;
    }

    const payload = {
      nombre: formValues.nombre.trim().toUpperCase(),
    };

    try {
      const respuesta = await putMarca(marca._id, payload);

      console.log("✅ Marca modificada:", respuesta);

      if (respuesta?.ok === false) {
        alert(respuesta?.error || "No se pudo modificar la marca");
        return;
      }

      handleClose();
    } catch (error) {
      console.error("❌ Error al modificar marca:", error);
      console.error("❌ Backend:", error?.response?.data);

      alert(
        error?.response?.data?.error ||
          error?.response?.data?.message ||
          "No se pudo modificar la marca. Revisá consola / Network."
      );
    }
  };

  return (
    <form onSubmit={handleSubmit}>
      <Modal.Body>
        <div className="form-group mt-3">
          <label>Marca</label>
          <input
            type="text"
            className="form-control"
            name="nombre"
            maxLength="50"
            minLength="2"
            required
            value={formValues.nombre}
            onChange={handleChange}
          />
        </div>
      </Modal.Body>

      <Modal.Footer>
        <Button type="submit" variant="dark">
          Guardar
        </Button>
      </Modal.Footer>
    </form>
  );
};

export default ModalFormMarca;